module.exports = "/src/views/player/oressale/assets/images/wood_pine.png";